import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ActionSheetController, ModalController } from "@ionic/angular";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";
import { Page } from "src/app/model/Page";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AppealDetailModel } from "src/app/model/AppealDetailModel";

import { DatePipe } from "@angular/common";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { InstallmentAppealModel } from "src/app/model/InstallmentAppealModel";
import { InstallmentExtendModel } from "src/app/model/InstallmentTypeModel";
import moment from "moment";
import { OfficialsService } from "src/app/services/officials.service";
import { isArray } from "util";

@Component({
  selector: "app-secure-view-payment-extension-dtl",
  templateUrl: "./payment-extension-dtl.component.html",
  styleUrls: ["./payment-extension-dtl.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PaymentExtensionDtlComponent implements OnInit {
  data: AppealDetailModel;
  // page: Page<AppealDetailModel>;
  dataSource: MatTableDataSource<InstallmentExtendModel> =
    new MatTableDataSource();
  applicationNo: number;
  appealType: string;
  appealDate: string;
  remark: string;
  extendDaysValue: string;
  isLoading: boolean = false;
  manualRejectedQuestions: any[] = [];
  documents: any[] = [];
  verifiedStatus: any[] = [];
  documentName: string = "";
  profileDetails: any[] = [];

  paymentExtensionArray: InstallmentExtendModel[] = [];

  areQuestionsNotAnswered: boolean;
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  newInstmantDate: string;
  progressSpinnerDialog: any = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isSearchDisabled: boolean = false;
  isAllowedForAppeal: boolean = false;
  isAppealApproved: boolean = false;

  appealHearingStatus: boolean = false;
  rejectStatus: boolean = false;
  isappealHearingType: boolean = false;

  dateColorFormat: Date;
  form: FormGroup = new FormGroup({});
  installmentAppealModel: InstallmentAppealModel[] = [];
  page: Page<InstallmentExtendModel>;
  displayedColumns: string[] = [
    "id",
    "installmentType",
    // "transactionId",
    "oldInstallmentEndDate",
    "extendDays",
    // "appealType",
    // "applicantStatus",

    // "transactionDate",
    // "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  showtable: number = 5000001;
  source: string;

  constructor(
    private route: ActivatedRoute,
    private paymentSettlementService: PaymentSettlementService,
    public actionSheetController: ActionSheetController,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private officialsService: OfficialsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // this.loadData();
    this.loadInstallment();
    this.loadApplicantData();

    this.form = new FormGroup({
      installmentFormList: new FormArray([]),
    });
  }

  loadApplicantData() {
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.paymentSettlementService
        .fetchDetailView(this.applicationNo)
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.data = data;
              // console.log("this.data", this.data);
            } else {
              this.paymentSettlementService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.isLoading = false;
            this.paymentSettlementService.errorToast(
              error?.error?.errorMessage || error?.error?.message
            );
          }
        );
    });
  }

  // isDateLessThanToday(date: string): boolean {
  //   const inputDate = date;
  //   const currentDate = new Date();
  //   const formattedDate = this.datePipe.transform(
  //     new Date(currentDate),
  //     "dd/MM/yyyy HH:mm:ss"
  //   );

  //   console.log(currentDate, inputDate, formattedDate)
  //   return inputDate < formattedDate;
  // }

  convertAndCompare(dateStr: string): boolean {
    try {
      const dateObj = new Date(dateStr);

      const currentDate = new Date();
      // currentDate.setHours(0, 0, 0, 0);

      if (dateObj <= currentDate) {
        return true;
      } else if (dateObj >= currentDate) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error("Invalid date format:", error);
      return false;
    }
  }

  isDateLessThanToday(date: string): boolean {
    // console.log(date, new Date(), new Date(date))
    // console.log(this.convertAndCompare(date));
    return new Date(date) <= new Date();
  }

  loadInstallment() {
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.officialsService
        .fetchPaymentDetails(this.applicationNo)
        .subscribe(async (page: any) => {
          // console.log(" data ", page);
          this.page = page;
          this.dateColorFormat = page.content.oldInstallmentEndDate;
          let installmentFormList: FormArray = this.form.get(
            "installmentFormList"
          ) as FormArray;

          for (let k = 0; k < page.content.length; k++) {
            let installmentObj = page.content[k];
            console.log("test", installmentObj);
            let frmGrp = new FormGroup({
              key: new FormControl(installmentObj.key),
              installmentType: new FormControl(installmentObj.installmentType),
              oldInstallmentEndDate: new FormControl(
                installmentObj.oldInstallmentEndDate
              ),
              oldInstallmentEndDateNew: new FormControl(
                installmentObj.oldInstallmentEndDateNew
              ),
              extendDaysValue: new FormControl(installmentObj.extendDaysValue),
              paymentStatus: new FormControl(installmentObj.paymentStatus),
              instPaymentInterestRate: new FormControl(
                installmentObj.instPaymentInterestRate
              ),
              newInstPaymentInterestRate: new FormControl(
                installmentObj.newInstPaymentInterestRate
              ),
            });
            this.isDateLessThanToday(installmentObj.oldInstallmentEndDate);

            installmentFormList.push(frmGrp);
            // console.log("frmGrp", frmGrp.value);
          }

          // if (page.content[0] !== null) {
          //   this.dataSource = new MatTableDataSource(page.content);
          // } else {
          //   this.dataSource = new MatTableDataSource<InstallmentTypeModel>([]);
          // }
        });
    });
  }
  // loadData() {
  //   this.route.params.subscribe((params: Params) => {
  //     this.applicationNo = +params["applicationNo"];
  //     this.appealType = params["appealType"];
  //     // this.source = params["source"];
  //     // console.log("this.appealType", this.appealType);
  //     this.isLoading = true;
  //     this.paymentSettlementService
  //       .fetchAppealDetailView(this.applicationNo, this.appealType)
  //       .subscribe(
  //         async (data: any) => {
  //           this.isLoading = false;
  //           // console.log("aala ka ethe", data);
  //           if (data.status === "SUCCESS") {
  //             this.data = data;

  //             this.isAllowedForAppeal = data.appealDate != null ? true : false;
  //             this.isAppealApproved =
  //               data.appealHearingStatus == "APPROVED" ? true : false;
  //             this.appealHearingStatus =
  //               data.appealHearingStatus == "Allowed_For_Hearing"
  //                 ? true
  //                 : false;
  //             this.rejectStatus =
  //               data.appealHearingStatus == "REJECTED" ? true : false;
  //             this.isappealHearingType =
  //               data.appealType == "PAYMENT_DEFAULTER" ? true : false;

  //             // console.log("this.data", this.data);
  //           } else {
  //             this.paymentSettlementService.errorToast(data.errorMessage);
  //           }
  //         },
  //         (error) => {
  //           this.isLoading = false;
  //           this.paymentSettlementService.errorToast(
  //             error?.error?.errorMessage || error?.error?.message
  //           );
  //         }
  //       );
  //   });
  // }

  // async approvedDocument() {
  //   this.paymentSettlementService
  //     .saveApprovedDocument(this.applicationNo.toString(), this.appealType)
  //     .subscribe((data) => {
  //       this.isLoading = false;
  //       // this.loadData();
  //       this._snackBar.open("Payment extension Successfully done", "Close", {
  //         horizontalPosition: "right",
  //         verticalPosition: "top",
  //         panelClass: "success-toast",
  //         duration: 3 * 1000,
  //       });
  //     });
  // }

  newExtendedDate(oldDate, extendDays) {
    // console.log('newExtendedDate call', oldDate , extendDays);
    if (oldDate && extendDays) {
      return moment(oldDate, "DD/MM/YYYY HH:mm:ss")
        .add(extendDays, "days")
        .format("DD/MM/YYYY HH:mm:ss");
    } else return null;
  }

  allowOnlyNumbersAndDecimal(event) {
    const key = event.key;
    const regex = /^[0-9.]$/i;
    return regex.test(key);
  }

  newInstPaymentInterestRateCal(oldInsRate, newInsRate) {
    // console.log('newInstPaymentInterestRateCal call', oldInsRate, newInsRate);
    // console.log(typeof (oldInsRate), typeof (newInsRate));
    if (+newInsRate) {
      console.log("Inner Method Call");
      return +oldInsRate + Number(newInsRate);
    } else return null;
  }

  async approvedPayment() {
    const currentDate = new Date();
    const hasError = this.form.value.installmentFormList.some((ur) => {
      const extendDaysValue = ur.extendDaysValue;
      const oldInstallmentEndDate = ur.oldInstallmentEndDate;
      const paymentStatus = ur.paymentStatus;

      let contractMoment = moment(oldInstallmentEndDate, "DD/MM/YYYY HH:mm:ss");
      let newDate = moment(contractMoment).add(extendDaysValue, "days");

      if (
        newDate.toDate() <= currentDate &&
        paymentStatus !== "PAYMENT_RECEIVED"
      ) {
        return true;
      } else {
        if (+extendDaysValue > 0) this.paymentExtensionArray.push(ur);
        return false;
      }
    });
    // const paymentError = this.form.value.installmentFormList.some((ur) => {
    //   const paymentStatus = ur.paymentStatus;
    //   console.log(
    //     "this.form.value.installmentFormList",
    //     this.form.value.installmentFormList
    //   );
    //   if (paymentStatus === "PAYMENT_RECEIVED") {
    //     return false;
    //   }
    //   return true;
    // });
    const paymentError = this.form.value.installmentFormList.some(
      (ur) =>
        ur.paymentStatus === "PAYMENT_RECEIVED" ||
        (ur.paymentStatus === "PAYMENT_NOT_RECEIVED" &&
          ur.extendDaysValue != null) ||
        (ur.paymentStatus === "PARTIAL_PAYMENT_RECEIVED" &&
          ur.extendDaysValue != null) ||
        (ur.paymentStatus === null && ur.extendDaysValue != null)
    );

    // console.log("paymentErrorpaymentError", paymentError);

    if (!paymentError) {
      if (hasError) {
        this._snackBar.open("Date less than current date", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
        // console.error("Date less than current date");
      }
      // this._snackBar.open("PAYMENT_RECEIVED", "Close", {
      //   horizontalPosition: "right",
      //   verticalPosition: "top",
      //   panelClass: "error-toast",
      //   duration: 3 * 1000,
      // });
    } else if (hasError) {
      this._snackBar.open("Date less than current date", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
      // console.error("Date less than current date");
    } else {
      if (Array.isArray(this.paymentExtensionArray)) {
        // console.log( this.paymentExtensionArray);
        this.officialsService
          .savePaymentExtension({
            remark: "",

            reject: "",
            approve: "APPROVED",
            applicationNo: this.applicationNo.toString(),
            appealType: this.appealType,
            appealResponsibilities: this.paymentExtensionArray,
          })
          .subscribe((data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this._snackBar.open("Payment Extension Successfully", "Close", {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "success-toast",
                duration: 3 * 1000,
              });
              this.router.navigate(["/secure", "payment-extension"]);
            } else {
              this.officialsService.errorToast(data.errorMessage);
            }
          });
      } else {
        this._snackBar.open("Please enter valid data.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    }
  }

  get installmentList() {
    return this.form.get("installmentFormList")["controls"];
  }
}
